import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { grey } from '@mui/material/colors';

// Fake data - replace with actual data fetching
const fakeTaskAssignmentRules = [
  { id: 1, name: 'New Booking', priority: 1, sourceName: 'SVP, Sales & Marketing', destinationName: 'Automated Process' },
  { id: 2, name: 'M FTAR', priority: 1, sourceName: 'Director, Direct Sales', destinationName: 'Automated Process' },
];

function Tasks() {
  return (
    <Card>
      <ArgonBox p={3} textAlign="center">
        <ArgonTypography variant="h6" textAlign="left">Fulfillment Task Assignment Rules</ArgonTypography>
        <ArgonBox py={3}>
          <TableContainer component={Paper}>
            <Table aria-label="fulfillment task assignment rules table">
              <TableHead sx={{ display: 'contents' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Priority</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Source Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Destination Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {fakeTaskAssignmentRules.map((option) => (
                  <TableRow key={option.id}>
                    <TableCell>{option.name}</TableCell>
                    <TableCell>{option.priority}</TableCell>
                    <TableCell>{option.sourceName}</TableCell>
                    <TableCell>{option.destinationName}</TableCell>
                  </TableRow>
              ))}
              </TableBody>
            </Table>
          </TableContainer>
        </ArgonBox>
      </ArgonBox>
    </Card>
  );
}

export default Tasks;